import './HTableOfContents.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { ArticleTemplateModule } from '~/schemes';

export interface TableOfContentsItem {
  id: string;
  text: string;
}

type TocStyle = ArticleTemplateModule['properties']['tocStyle'];

export const HTableOfContents = tsx.component({
  name: 'HTableOfContents',
  functional: true,

  props: {
    items: {
      type: Array as PropType<TableOfContentsItem[]>,
      required: true,
    },
    tocStyle: {
      type: String as PropType<TocStyle>,
      default: 'standard',
    },
  },

  render(h, { props, parent }): VNode {
    const { items, tocStyle } = props;

    const handleClick = (e: MouseEvent, targetId: string) => {
      e.preventDefault();
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    };

    return (
      <div
        staticClass="h-table-of-contents"
        class={`h-table-of-contents--${tocStyle}`}>
        <div staticClass="h-table-of-contents__title">
          {parent.$t('label.tableOfContents')}
        </div>
        <ul>
          {items.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                onClick={(e: MouseEvent) => handleClick(e, item.id)}>
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  },
});
